/**
 * TvlaPieChart - Pie chart used inside the TVLA Report.
 *
 * Renders one slice per VIN generation. Generations are dynamic (not hardcoded);
 * the component simply renders whatever data it receives.
 *
 * Expected data format (nivo pie): [{ id, label, value }]
 */
import React from 'react';
import { ResponsivePie } from '@nivo/pie';

// Colour palette cycled across the dynamic generations.
const PALETTE = [
    '#1f6f9c', '#ed7d31', '#1e7a34', '#39a9db',
    '#7f5fc4', '#c44f4f', '#4fae9c', '#b7823a',
    '#5b8a2b', '#8e6fb0'
];

const getTooltip = ({ datum }) => (
    <div style={{
        background: 'white',
        padding: '9px 12px',
        border: '1px solid #ccc',
        borderRadius: '4px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        fontSize: '14px',
        fontWeight: 500,
        color: '#333'
    }}>
        <div style={{ marginBottom: '4px', fontWeight: 600, color: datum.color }}>
            {datum.label}
        </div>
        <div>
            Count: <strong>{datum.value}</strong>
        </div>
    </div>
);

const TvlaPieChart = ({ data }) => {
    if (!data || data.length === 0) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
                No records available to display
            </div>
        );
    }

    return (
        <ResponsivePie
            data={data}
            margin={{ top: 40, right: 80, bottom: 90, left: 80 }}
            innerRadius={0}
            padAngle={0.4}
            cornerRadius={0}
            activeOuterRadiusOffset={8}
            colors={PALETTE}
            borderWidth={1}
            borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
            enableArcLinkLabels={false}
            enableArcLabels={true}
            arcLabel={(d) => `${d.value}`}
            arcLabelsRadiusOffset={0.6}
            arcLabelsSkipAngle={10}
            arcLabelsTextColor="#333333"
            tooltip={getTooltip}
            legends={[
                {
                    anchor: 'bottom',
                    direction: 'row',
                    justify: false,
                    translateX: 0,
                    translateY: 72,
                    itemsSpacing: 4,
                    itemWidth: 90,
                    itemHeight: 18,
                    itemDirection: 'left-to-right',
                    itemOpacity: 0.85,
                    symbolSize: 14,
                    symbolShape: 'square',
                    effects: [
                        {
                            on: 'hover',
                            style: { itemOpacity: 1 }
                        }
                    ]
                }
            ]}
            animate={true}
        />
    );
};

export default TvlaPieChart;
